import { DropdownItem, TextBase, TextCaption, Tooltip } from '@carboncopyco/ui';
import type React from 'react';
import { useRef } from 'react';

type ColumnOptionsItemProps = {
  label: string;
  onClick: () => void;
  iconLeft?: React.ReactNode;
  disabled?: boolean;
  tooltipTitle?: string;
  tooltipDescription?: string;
};

export const ColumnOptionsItem = ({
  label,
  iconLeft,
  onClick,
  disabled,
  tooltipTitle,
  tooltipDescription,
}: ColumnOptionsItemProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={tooltipRef}>
        <DropdownItem
          label={
            <TextBase
              label={label}
              color="text-ds-natural-600"
            />
          }
          iconLeft={<div className="text-ds-natural-600">{iconLeft}</div>}
          onClick={onClick}
          disabled={disabled}
          aria-label={label}
        />
      </div>
      {(tooltipTitle || tooltipDescription) && (
        <Tooltip
          fixedWidth={true}
          shadow="md"
          noArrow
          interactiveBorder={0}
          delay={[700, 0]}
          placement="top-start"
          anchorRef={tooltipRef}
          appendTo={() => document.body}
          offset={[0, -10]}
        >
          <div className="flex flex-col rounded-md max-w-max pointer-events-auto w-80 bg-ds-accent3-100 flex px-4 py-2.5 text-ds-natural font-ds-inter text-ds-200 font-ds-light tracking-ds-tight leading-ds-200">
            <TextCaption
              fontWeight="font-ds-medium"
              label={tooltipTitle}
            />
            <TextCaption label={tooltipDescription} />
          </div>
        </Tooltip>
      )}
    </>
  );
};
